import React from 'react';
import CertCard from './CertCard';
import { Container, Row } from 'react-bootstrap';
import { Jumbotron } from './migration';
import { motion } from 'framer-motion';

const Certifications = ({ certifications }) => {
  return (
    <section className="section" id="certifications">
      <Jumbotron fluid className="certifications">
        <Container>
          <motion.h2
            className="display-4 mb-5 text-center"
            initial={{ opacity: 0, y: -24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.45 }}
            style={{ fontWeight: 700, color: 'var(--text-primary)' }}
          >
            {certifications.heading}
          </motion.h2>
          <Row>
            {certifications.data.map((data, index) => {
              return <CertCard key={index} data={data} index={index} />;
            })}
          </Row>
        </Container>
      </Jumbotron>
    </section>
  );
};

export default Certifications;
